module.exports = __webpack_public_path__ + "img/setStart.8550a60b.svg";